var page = 1;
var loadingData = false;
var form = $("#promo-search-form");

$(function () {
    createInfiniteScroll()
    createCategoryInputFields()
    createCategoryScrollManagement()
    createSelects()
    pageAddToCart()
});

function pageAddToCart() {
    $(document).on('submit', '.promo-atc', function (e) {
        e.preventDefault();
        const $this = $(this);
        const action = $this.attr('action');
        const productIdInput = $this.find("input[name=product_id]")
        const productId = productIdInput.val();
        const submitButton = $this.find('button[type=submit]')

        submitButton.html("<span class='text-white'>Sto aggiungendo</span> <i class='fas fa-circle-notch fa-spin text-white'></i>");
        submitButton.addClass('disabled')
        submitButton.blur()

        $.ajax({
            url: '/cart/add',
            data: {product_id: productId, access_source: 'PROMO_PAGE'},
            method: 'POST',
            xhrFields: {
                withCredentials: true
            }
        }).done(function (response, status, xhr) {
            if (response.data) {
                location.reload()
            }
        }).fail(function (error) {
        })

    })
}

function createCategoryInputFields() {
    $('.promo-category-filter').click(function () {
        const categoryId = $(this).data('value');
        const categoryInput = $("select[name='category']");
        $('#promotion-search').val('')

        categoryInput.val(categoryId);
        form.submit();
    })

    $('#clear-category-filter').click(function () {
        const categoryInput = $("select[name='category']");
        categoryInput.val('');
        form.submit();
    })
}

function createSelects() {

    const corsiSelects = $('.corsi-select');

    corsiSelects.each(function () {
        const corsiSelect = $(this);

        const allowClear = !!corsiSelect.data('allow-clear');
        const selectedAppend = corsiSelect.data('selected-append') || '';
        const placeholder = corsiSelect.data('placeholder')

        corsiSelect.select2({
            allowClear: allowClear,
            templateSelection: function (state) {
                // Se non ha ID è il placeholder, non aggiungo niente
                if (!state.id) {

                    return state.text;
                }

                // Inserisco l'append richiesto
                var $state = $(
                    '<span><span>'
                );

                $state.find("span").text(selectedAppend + state.text)

                return $state;
            },
            minimumResultsForSearch: -1,
            placeholder: placeholder
        });

        // Selezionato un valore
        corsiSelect.on('select2:select', function () {
            $('#promotion-search').val('')
            form.submit()
        })

        // Cliccato sulla x del select
        // Avoid open select after clear inputs
        // https://stackoverflow.com/questions/29618382/disable-dropdown-opening-on-select2-clear
        corsiSelect.on('select2:clear', function () {
            $(this).data('unselecting', true);
        }).on('select2:opening', function (e) {
            if ($(this).data('unselecting')) {
                $(this).removeData('unselecting');
                e.preventDefault();
                form.submit()
            }
        });

        // Esce la select default brutta prima che si carichi quella di select2
        corsiSelect.removeClass('d-none')
    })
}

function createCategoryScrollManagement() {
    var sticky = $('.sticking-block');
    var stickyHead = sticky.offset().top
    var lastScrollTop = 0;
    var lastScroll, currentScroll;

    function updateStickyPosition(sticky, position, top, bottom = '') {
        sticky.css(
            {
                position: position,
                top: top,
                bottom: bottom
            }
        );
    }

    function calculateHeadOffset() {
        var corsiBanner = $('#corsi-banner');

        return (corsiBanner.offset().top + corsiBanner.height());
    }

    $(window).scroll(function () {
        var st = $(this).scrollTop();
        var scroll = $(window).scrollTop()
        var headOffset, lastPosition, positionToUpdate, pixelScrolled;
        var promoContent = $('#promo-content');

        lastScroll = currentScroll || 0;
        currentScroll = scroll;

        var promoContentHeight = promoContent.height();
        var stickingBlockHeight = sticky.height();

        if (stickingBlockHeight > promoContentHeight) {
            updateStickyPosition(sticky, 'relative', 'auto')
            lastScrollTop = st;

            return;
        }

        var stickyPosition = sticky.offset().top + stickingBlockHeight;
        var promoContentPosition = promoContent.offset().top + promoContentHeight;
        var windowHeight = scroll + window.innerHeight;

        if (stickyPosition > promoContentPosition) {
            updateStickyPosition(sticky, 'fixed', '', windowHeight - promoContentPosition);
            lastScrollTop = st;
            return;
        }

        if (st > lastScrollTop) {
            // SCROLL VERSO IL BASSO
            var lastPositionType = sticky.css('position')

            if (scroll <= stickyHead || windowHeight > sticky.offset().top + sticky.height()) {

                var containerHeight = $('#promo-container-list').height();
                var stickyHeight = sticky.height();

                if (stickyHeight >= containerHeight) {
                    sticky.css(
                        {
                            position: 'fixed',
                            bottom: 0
                        }
                    );
                }

                lastScrollTop = st;
                return;
            }

            headOffset = calculateHeadOffset() || 0;
            lastPosition = parseInt(sticky.css('top'))
            pixelScrolled = currentScroll - lastScroll;
            positionToUpdate = isNaN(lastPosition) || lastPositionType === 'relative' ? headOffset : lastPosition - pixelScrolled

            updateStickyPosition(sticky, 'fixed', positionToUpdate)
        } else {
            // SCROLL VERSO L'ALTO
            if (scroll < stickyHead) {
                lastScrollTop = st;
                updateStickyPosition(sticky, 'relative', 0)

                return;
            }

            pixelScrolled = lastScroll - currentScroll;
            headOffset = calculateHeadOffset() + 20 || 0;
            lastPosition = parseInt(sticky.css('top'))
            positionToUpdate = Math.min(lastPosition + pixelScrolled, headOffset)

            updateStickyPosition(sticky, 'fixed', positionToUpdate)
        }

        lastScrollTop = st;
    });
}

function createInfiniteScroll() {
    function spinner() {
        return {
            hide: () => {
                $('#promo-loader').addClass('d-none')
            },
            show: () => {
                $('#promo-loader').removeClass('d-none')
            },
        }
    }

    function loadData() {
        var params = location.search !== '' ? location.search + '&page=' + page : '?page=' + page

        $.ajax(
            {
                url: params,
                type: "get",
                beforeSend: function () {
                    spinner().show()
                    loadingData = true;
                }
            })
            .done(function (data) {
                spinner().hide()
                var html = data.data.html;

                if (!html) {
                    return;
                }

                $('#promo-content').append(html)
                loadingData = false;
            })
            .fail(function (jqXHR, ajaxOptions, thrownError) {
                spinner().hide()
            });
    }

    $(window).scroll(function () {
        if ($(window).scrollTop() + $(window).height() >= $("#promo-container-list").height()) {
            if (loadingData) {
                return;
            }

            page++;
            loadData()
        }
    });
}
